import { FormControl, FormHelperText } from '@material-ui/core'
import Switch from '@material-ui/core/Switch'
import { Control, useController } from 'react-hook-form'
import { FieldProps } from './interfaces'
import { useToggleFieldStyles } from './ToggleField.style'

export type ToggleFieldProps = {
  // eslint-disable-next-line
  control: Control | any
} & FieldProps

export const ToggleField = (props: ToggleFieldProps) => {
  const { control, name, label, defaultValue, rules = {}, disabled } = props
  const style = useToggleFieldStyles()
  const {
    field,
    fieldState: { error },
  } = useController({ control, name, defaultValue, rules })

  return (
    <FormControl className={style.switch}>
      <label>{label}</label>
      <Switch
        {...field}
        disabled={disabled}
        checked={field.value}
        onClick={(e) => e.stopPropagation()}
        color="primary"
      />
      <FormHelperText>{error?.message || ' '}</FormHelperText>
    </FormControl>
  )
}
